import { render, staticRenderFns } from "./youthSelector.vue?vue&type=template&id=220bf702&scoped=true&"
import script from "./youthSelector.vue?vue&type=script&lang=js&"
export * from "./youthSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bf702",
  null
  
)

export default component.exports